var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Elements",
    transform: "translate(-245.000000, -416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(9.000000, 58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(220.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Travel,-Transport-+-Tracking-/-shipment_",
    transform: "translate(14.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.9999926e-8,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,2 L6.00000005,2 C4.89543055,2 4.00000005,2.8954305 4.00000005,4 L4.00000005,16 L20,16 L20,4 C20,2.8954305 19.1045695,2 18,2 Z M6.00000005,4 L11,4 L11,8 L6.00000005,8 L6.00000005,4 Z M6.00000005,14 L6.00000005,10 L11,10 L11,14 L6.00000005,14 Z M18,14 L13,14 L13,10 L18,10 L18,14 Z M13,8 L13,4 L18,4 L18,8 L13,8 Z M22,18 L22,20 L20,20 L20,22 L16,22 L16,20 L8.00000005,20 L8.00000005,22 L4.00000005,22 L4.00000005,20 L2.00000005,20 L2.00000005,18 L22,18 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipment);
export default __webpack_public_path__ + "static/media/shipment.4fc04a70ecbcd1d2fe8ae9ba430d1dd0.svg";
export { ForwardRef as ReactComponent };